export const GET = 'GET'
export const LIST = 'LIST'
export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE '
export const DELETE = 'DELETE'
export const UPSERT = 'UPSERT'
export const MULTI_UPSERT = 'MULTI_UPSERT'
export const FUNCTIONAL_CALL = 'FUNCTIONAL_CALL'
